import React from 'react'
import Smartview from 'widgets/smartviews/Smartview'
import { ForEachModel, Model, ValueToCollection, WhenModelValue } from '@morningtrain/react-resources'
import PropTypes from 'prop-types'
import * as Displays from '@morningtrain/react-displays'
import SpecialDaysDayFilter from 'support/filters/SpecialDaysDayFilter'
import SmartviewTextGroup from 'widgets/smartviews/partials/SmartviewTextGroup'
import SmartviewText from 'widgets/smartviews/partials/SmartviewText'
import SmartviewContentSeparator from 'widgets/smartviews/partials/SmartviewContentSeparator'
import * as UI from 'ui'
import { Translation } from '@morningtrain/react-translations'
import DownloadFile from 'support/displays/DownloadFile'
import { StaticFilter } from '@morningtrain/react-filters'

export default function ViewSpecialEventsSmartview ({
  date,
  scheduleId
}) {
  return (
    <Smartview>
      <Model resourceName='shifts.special_days' operationName='index'>
        <SpecialDaysDayFilter date={date} />
        <StaticFilter name='schedule' value={scheduleId} />
        <ValueToCollection name='special_days'>
          <SmartviewContentSeparator />
          <SmartviewTextGroup highlight>
            <ForEachModel>
              <SmartviewText className='py-2'>
                <UI.WithSubtitle subtitle={(
                  <>
                    <Displays.Date name='starts_at' /> - <Displays.Date name='ends_at' />
                  </>
                )}
                >
                  <UI.Text size='base' weight='medium'>
                    <Displays.Text name='name' />
                  </UI.Text>
                </UI.WithSubtitle>
                <p>
                  <Displays.Text name='description' />
                </p>
                <WhenModelValue name='file_name'>
                  <DownloadFile name='file_url' filenameAttribute='file_name'>
                    <Translation name='generic.view_file' className='cursor-pointer' />
                  </DownloadFile>
                </WhenModelValue>
              </SmartviewText>
            </ForEachModel>
          </SmartviewTextGroup>
        </ValueToCollection>
      </Model>
    </Smartview>
  )
}

ViewSpecialEventsSmartview.propTypes = {
  scheduleId: PropTypes.number.isRequired,
  date: PropTypes.string.isRequired
}
